module.exports = __webpack_public_path__ + "img/智驹-APP介绍-中文_2_06.cd162f49.jpg";